import { Link } from 'react-router-dom';

import {ReactComponent as Arrow} from '../../images/icons/Arrows/arrow-left.svg';

const NoAccess = () => {
    return <div className="error-404">Access to this section is denied<Link to="/"><Arrow /> Return back to home</Link></div>
};

export default NoAccess;